import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}

interface BinProps extends StyledProps {
  color?: string;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const BinSolidSVG: React.FunctionComponent<BinProps> = ({
  color = "#FFF",
  ...rest
}) => {
  return (
    <StyledContainer {...rest} data-testid="solid-bin-container">
      <svg
        aria-hidden="true"
        focusable="false"
        data-icon="bin-solid"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 18 20"
        width="100%"
        height="100%"
      >
        <title id="bin-solid-svg">Bin solid svg</title>
        <path
          fill={color}
          d="M1.286 18.125c0 1.036.863 1.875 1.928 1.875h11.572c1.065 0 1.928-.84 1.928-1.875V5H1.286v13.125zm10.928-10c0-.345.288-.625.643-.625.355 0 .643.28.643.625v8.75c0 .345-.288.625-.643.625-.355 0-.643-.28-.643-.625v-8.75zm-3.857 0c0-.345.288-.625.643-.625.355 0 .643.28.643.625v8.75c0 .345-.288.625-.643.625-.355 0-.643-.28-.643-.625v-8.75zm-3.857 0c0-.345.288-.625.643-.625.355 0 .643.28.643.625v8.75c0 .345-.288.625-.643.625-.355 0-.643-.28-.643-.625v-8.75zM17.357 1.25h-4.821l-.378-.73C11.995.2 11.66 0 11.294 0H6.702c-.366-.001-.7.2-.86.52l-.378.73H.643c-.355 0-.643.28-.643.625v1.25c0 .345.288.625.643.625h16.714c.355 0 .643-.28.643-.625v-1.25c0-.345-.288-.625-.643-.625z"
        ></path>
      </svg>
    </StyledContainer>
  );
};

export default BinSolidSVG;
